import React from 'react'

import useStyles from './error-modal.style'

import { useDispatch, useSelector } from 'react-redux'
import { ERROR_MODAL_CLOSE } from '@redux/actions/types'

import Icon from '@components/icon/icon.component'
import Modal from '@components/modal/modal.component'

const ErrorModal = props => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const isVisible = useSelector(state => state.error.showErrorModal)

  const onClose = () => dispatch({ type: ERROR_MODAL_CLOSE })

  return (
    <Modal
      isVisible={isVisible}
      onClose={onClose}
    >
      <div>
        <div className={classes.iconContainer}>
          <Icon type='alert' />
        </div>
        <div className={classes.modalTextContainer}>
          <div className={classes.header}>There was an error processing your request.</div>
        </div>
      </div>
    </Modal>
  )
}

export default ErrorModal
